/* WinMaestros cart preview: one floating image for all native set/cart chip images. */
(function () {
  if (window.__wmCartImagePreviewInstalled) return;
  window.__wmCartImagePreviewInstalled = true;

  function init() {
    if (document.getElementById('wm-cart-image-preview')) return;

    const popup = document.createElement('div');
    popup.id = 'wm-cart-image-preview';
    popup.className = 'wm-cart-image-preview';
    popup.hidden = true;
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-label', 'Product image preview');
    popup.innerHTML =
      '<div class="wm-cart-image-preview__panel">' +
        '<button type="button" class="wm-cart-image-preview__close" aria-label="Close image preview">×</button>' +
        '<img class="wm-cart-image-preview__photo" alt="">' +
        '<div class="wm-cart-image-preview__caption"></div>' +
      '</div>';
    document.body.appendChild(popup);

    const image = popup.querySelector('.wm-cart-image-preview__photo');
    const caption = popup.querySelector('.wm-cart-image-preview__caption');
    const closeButton = popup.querySelector('.wm-cart-image-preview__close');
    const coarse = () => matchMedia('(hover: none), (pointer: coarse)').matches;
    let active = null;
    let isTouchOpen = false;

    function close() {
      if (popup.hidden) return;
      popup.hidden = true;
      popup.classList.remove('is-touch');
      popup.style.top = '';
      popup.style.left = '';
      active = null;
      isTouchOpen = false;
    }

    function show(trigger, touchMode) {
      const src = trigger?.dataset.wmCartPreviewSrc;
      if (!src) return;
      if (active !== trigger || popup.hidden) {
        image.src = src;
        image.alt = trigger.dataset.wmCartPreviewAlt || 'Enlarged product image';
        caption.textContent = trigger.dataset.wmCartPreviewAlt || '';
      }
      active = trigger;
      isTouchOpen = touchMode;
      popup.classList.toggle('is-touch', touchMode);
      popup.hidden = false;

      if (touchMode) {
        popup.style.left = '';
        popup.style.top = '';
        closeButton.focus({ preventScroll: true });
        return;
      }

      // Fixed positioning keeps previews out of cart cards with overflow clipping.
      const r = trigger.getBoundingClientRect();
      const width = popup.offsetWidth;
      const height = popup.offsetHeight;
      const edge = 12;
      let left = r.right + 14;
      if (left + width + edge > innerWidth) left = r.left - width - 14;
      left = Math.max(edge, Math.min(left, innerWidth - width - edge));
      const top = Math.max(edge, Math.min(r.top - 12, innerHeight - height - edge));
      popup.style.left = left + 'px';
      popup.style.top = top + 'px';
    }

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch' || coarse() || isTouchOpen) return;
      const trigger = event.target.closest?.('[data-wm-cart-preview-src]');
      if (!trigger) return;
      if (trigger.contains(event.relatedTarget)) return;
      show(trigger, false);
    });

    document.addEventListener('pointerout', (event) => {
      if (isTouchOpen || !active) return;
      const trigger = event.target.closest?.('[data-wm-cart-preview-src]');
      if (trigger !== active) return;
      if (trigger.contains(event.relatedTarget)) return;
      close();
    });

    document.addEventListener('focusin', (event) => {
      if (coarse() || isTouchOpen) return;
      const trigger = event.target.closest?.('[data-wm-cart-preview-src]');
      if (trigger) show(trigger, false);
    });

    document.addEventListener('focusout', (event) => {
      if (!isTouchOpen && active && active.contains(event.target)) close();
    });

    document.addEventListener('click', (event) => {
      if (event.target === closeButton || (isTouchOpen && popup.contains(event.target))) {
        close();
        return;
      }
      const trigger = event.target.closest?.('[data-wm-cart-preview-src]');
      if (trigger && coarse()) {
        event.preventDefault();
        if (isTouchOpen && trigger === active) close();
        else show(trigger, true);
      } else if (isTouchOpen && !popup.contains(event.target)) {
        close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
    document.addEventListener('scroll', close, { passive: true, capture: true });
    window.addEventListener('resize', close);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
